export default "__VITE_ASSET__5bec2745__"